export const SET_FILE_CONTENT_RESULT = "SetFileContentResult"